import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { GtmEventType } from './gtmEventType';
import {
    buildAiAssetSearch,
    GA4AiAssetSearchEvent,
    AiAssetSourceEvent,
    trimToUndefined,
    isValidAiAssetSearch,
} from './aiAssetAnalyticsContract';

export class GtmAiAssetDetailSearchType extends GtmEventType {
    canHandle(event: AiAssetSourceEvent): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_FILTER_SEARCH &&
            event.aiAssetAnalytics?.kind === 'search' &&
            Boolean(event.aiAssetAnalytics.aiAssetKind) &&
            Boolean(trimToUndefined(event.aiAssetAnalytics.searchTerm))
        );
    }

    getBody(event: AiAssetSourceEvent): GA4AiAssetSearchEvent {
        return buildAiAssetSearch(event);
    }

    isValidEvent(event: GA4AiAssetSearchEvent): boolean {
        return isValidAiAssetSearch(event);
    }
}
